import React, {Component} from "react";
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { setModalNewsLetter } from '../../redux/actions';
import NewsLetter from './NewsLetter';

import './ModalNewsLetter.css'

class ModalNewsLetter extends Component {
  componentDidUpdate(prevProps) {
    if (prevProps.count !== this.props.count) {
      this.onCountUpdate();
    }
  }

  onCountUpdate() {
    if (this.props.count >= 2 && this.props.newsletter === '') {
      this.props.setModalNewsLetter('visible');
    }
  }

  onClose() {
    this.props.setModalNewsLetter('seen');
  }

  render() {
    return (
      <div className={'modal-newsletter'+(this.props.newsletter === 'visible' ? ' open' : '')}>
        <div>
          <span className="close" onClick={(e) => { this.onClose(e); }} />
          <NewsLetter />
        </div>
      </div>
    )
  }
}

ModalNewsLetter.propTypes = {
  count: PropTypes.number.isRequired,
}

const mapStateToProps = state => {
  return {
    count: state.count,
    newsletter: state.newsletter,
  }
};

const mapDispatchToProps = {
    setModalNewsLetter,
};

export default connect(mapStateToProps,mapDispatchToProps)(ModalNewsLetter);



// WEBPACK FOOTER //
// ./src/components/NewsLetter/ModalNewsLetter.js